/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSummerCampTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSummerCamp,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Camp Under the Stars!",
    "Summer Camp Awaits!",
    "Adventure in the Great Outdoors!",
  ],
  title: "Summer Camp",
  description: "Organize a fun summer camp experience.",
  longDescription:
    "Gather your friends for an adventurous summer camp! Choose a date, decide on activities to enjoy, and plan meals for the camp!",
  emoji: "🏕",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Summer Camp",
          emoji: "🏕",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the summer camp?",
          emoji: "📅",
          completeAction: {
            question: "Decide on activities for the camp?",
            description: "What activities should we include during the camp?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What activities should we consider?",
                emoji: "🎉",
                completeAction: {
                  question: "Decide on meals?",
                  description: "What meals should we plan for the camp?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What meals should we bring?",
                      emoji: "🍽",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Great Outdoors!",
    outroDescription: "Your summer camp plans are set! Enjoy the adventure!",
  },
};
